<nb-card class="dialog-card">
  <nb-card-header>Transferir de turma</nb-card-header>
  <nb-card-body>
    <p class="muted">
      <strong>{{ matricula.pessoaNome }}</strong> — sairá de
      <strong>{{ matricula.turmaNome }}</strong>
    </p>
    <app-autocomplete
      rotulo="Turma de destino"
      placeholder="Digite parte do nome ou o ano"
      [opcoes]="opcoesTurma"
      [selecionadoId]="turmaEntradaId"
      (selecionadoIdChange)="turmaEntradaId = $event"
      [buscaNoServidor]="true"
      [carregando]="carregandoTurmas"
      (buscar)="buscarTurmas($event)"
      msgSemResultado="Nenhuma turma encontrada"
    ></app-autocomplete>
  </nb-card-body>
  <nb-card-footer class="footer-actions">
    <button nbButton status="basic" (click)="fechar()" [disabled]="salvando">Cancelar</button>
    <button nbButton status="warning" (click)="salvar()" [disabled]="salvando || !turmaEntradaId">Transferir</button>
  </nb-card-footer>
</nb-card>
